module.exports = __webpack_public_path__ + "img/sensotex_mob.1e1d526.webp";